export default __webpack_public_path__ + "4bbf8be7c5b9664466f74032efa70452.png";